import React, {useState} from 'react';
import {observer} from 'mobx-react';
import {Form, Input, Button} from 'antd';
import store from "./store";

import styles from './layout.module.less'


// the hook
import { useTranslation } from 'react-i18next';

export default observer(function () {
  const {t, i18n} = useTranslation()
  const [loading, setLoading] = useState(false)
  const onFinish = values => {
    setLoading(true)
    store.updatePassword(values).finally(() => setLoading(false))
  }

  const layout = {
    labelCol: {span: 8},
    wrapperCol: {span: 8},
  }

  const tailLayout = {
    wrapperCol: {offset: 8, span: 8},
  }

  return (
    <React.Fragment>
      <div className={[styles.cart, 'rest-nav1'].join(" ")}>

        <div className={styles.listTitle}>
          <span className={styles.title}>{t('修改密码')}</span>
        </div>
        <div className="mainBox">


          <Form
            {...layout}
            name="basic"
            className={styles.form}
            onFinish={onFinish}
          >
            <Form.Item
              label={t('原登录密码')}
              name="old"
              hasFeedback
              rules={[
                {required: true, message: t('请输入6-10位由数字字母特殊符号组成的密码!')},
                {pattern: /[a-zA-Z0-9-*/+.~!@#$%^&()]{6,10}/, message: t('请输入6-10位由数字字母特殊符号组成的密码!')}
              ]}>
              <Input.Password className='rest-password' placeholder={t('请输入6-10位由数字字母特殊符号组成的密码')}/>
            </Form.Item>

            <Form.Item
              label={t('新的登录密码')}
              name="password"
              hasFeedback
              rules={[
                {required: true, message: t('请输入6-10位由数字字母特殊符号组成的密码!')},
                {pattern: /[a-zA-Z0-9-*/+.~!@#$%^&()]{6,10}/, message: t('请输入6-10位由数字字母特殊符号组成的密码!')}
              ]}
            >
              <Input.Password className='rest-password' placeholder={t('请输入6-10位由数字字母特殊符号组成的密码')}/>
            </Form.Item>

            <Form.Item
              label={t('确认新的登录密码')}
              name=""
              dependencies={['password']}
              hasFeedback
              rules={[
                {required: true, message: '请再次输入密码!'},
                ({getFieldValue}) => ({
                  validator(rule, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject('两次输入的密码不匹配!');
                  },
                }),
              ]}>
              <Input.Password className='rest-password' placeholder={t('请再次输入密码')}/>
            </Form.Item>


            <Form.Item {...tailLayout}>
              <Button className={styles.btn} type="primary" htmlType="submit" size='large' loading={loading}>{t('确定')}</Button>
            </Form.Item>
          </Form>


        </div>

      </div>
    </React.Fragment>
  )
})
